import { DateTime } from "luxon";

export interface SelfSchedulingConfigResponseModel {
  isFreshRemoteTypeAppointment?: boolean;
  isFreshFacilityTypeAppointment?: boolean;

  isRescheduleAllowed?: boolean;
  isCancellationAllowed?: boolean;

  isLimitNoOfCancelAppointments?: boolean;
  isLimitNoOfRescheduleAppointments?: boolean;

  maxCancelAllowed?: number | null;
  maxRescheduleAllowed?: number | null;

  isRescheduleRemoteAppointmentType: number;
  isRescheduleFacilityAppointmentType: number;

  isCustomConfigured: boolean;
}

export class SelfSchedulingConfigResModel {
  id: number;
  name: string;
  description: string;
  selfSchedulingConfigObj: string;
  isDefaultConfig?: boolean;
}


export class SelfSchedulingConfigReqModel {
  id?: number = 0;
  name?: string;
  description?: string;
  selfSchedulingConfigObj?: string;
  isDefaultConfig?: boolean;
  selfSchedulingConfigJson: string;
  modifiedByUserInfoId: number;
}
export interface DuplicateConfigDetailsModel {
  configName: string;
  overlappingBranchIds: string[];
  overlappingClassificationIds: string[];
  overlappingInsuranceIds: string[];
}

export interface SelfSchedulingConfigResponseDto {
  success: boolean;
  duplicateConfigList?: DuplicateConfigDetailsModel[];
  message: string
}


export interface SelfSchedulingConfigDetailsModel {
  isFreshRemoteTypeAppointment?: boolean | null;
  isFreshFacilityTypeAppointment?: boolean | null;
  isCancellationAllowed?: boolean | null;
  isLimitNoOfCancelAppointments?: boolean | null;
  maxCancelAllowed?: number | null;
  isRescheduleAllowed?: boolean | null;
  isLimitNoOfRescheduleAppointments?: boolean | null;
  maxRescheduleAllowed?: number | null;
  isRescheduleRemoteAppointmentType?: boolean | null;
  isRescheduleFacilityAppointmentType?: boolean | null;
  templateId?: number;
  classificationIds?: string;
  branchIds?: string;
  insuranceIds?: string;
}

export interface SelfSchedulingGeneralSetupModel {
  leadTime?: number;
  numOfDays?: number;
  unreconciled?: number;
  displayNote?: boolean;
  displayDueAmount?: boolean;
  slotDuration?: number;
  slotBasedOnClassification?: boolean;
  modifiedByUserInfoId?: number;
  isEnabled?: boolean;
  isCustomConfig?: boolean;
  labels: LabelConfigModel[];
  isDefault: boolean;
  expiryPeriodAppointmentLink: boolean;
  expiryPeriod?: string;
  expiryPeriodDuration?: number;
  enableGroupSession:boolean
}

export interface LabelConfigModel {
  key: string;
  value: string;
  defaultValue: string;
  isEditMode?: boolean;
}


export interface SelfSchedulingConfigModel {
  id?: number;
  name?: string;
  description?: string;
  jsonValue?: SelfSchedulingConfigDetailsModel;
  isDefault: boolean;
}

export interface SelfSchedulingWrapper {
  setup?: SelfSchedulingGeneralSetupModel;
  configs?: SelfSchedulingConfigModel[];
  modifiedByUserInfoId: number;
  totalCustomeConfig?: number;
}

export interface DuplicateConfigDetails {
  configName: string;
  overlappingBranchIds: string[];
  overlappingClassificationIds: string[];
  overlappingInsuranceIds: string[];
  message: string;
}

export interface DuplicateParameters {
  type: string;
  values: string;
}

export class SalesOrderHistoryCountModel {
  salesOrderId: number;
  canceledCount: number;
  rescheduleCount: number;
}

export class VerifyYourIdentityModel {
  patientId: number;
  lastName: string;
  dob: string;
  appointmentLink?: string;
  message: string;
  isLocked: boolean;
}
